import leaveSubItem from '@/api/hr/leave-sub-item'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  employeeTypes: [],
  leaveTypes: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  SET_LEAVE_TYPES(state, data) {
    state.leaveTypes = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )
    return leaveSubItem.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return leaveSubItem.store(data)
  },

  update(context, data) {
    return leaveSubItem.update(data)
  },

  destroy(context, id) {
    return leaveSubItem.destroy(id)
  },

  async dataBeforeCreate(context) {
    if (!context.state.leaveTypes.length > 0) {
      let response = await leaveSubItem.leaveType()
      context.commit('SET_LEAVE_TYPES', response.data)
    }
  }
}
